import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { ProgressSpinner } from 'primereact/progressspinner';
import ErrorMessage from '../../../../components/messages/ErrorMessage';
import { useCompanyContext } from '../../../../context/CompanyContext';
import { fetchClaims } from '../../../../services/Insurance/Claim';
import ClaimsTable from './ClaimsTable';
import { useFormContext } from 'react-hook-form';
import { ClaimFiltersOptions } from '../ClaimFilters';
import { useClaimSummaryContext } from '../ClaimContext';
import { Status } from '@/src/app/Interfaces/system/Generic.interfaces';

const ClaimsTableContainer = React.forwardRef<HTMLDivElement>(() => {
  const { selectedCompany } = useCompanyContext();
  const { data, setData } = useClaimSummaryContext();
  const { watch } = useFormContext<ClaimFiltersOptions>();
  const filters = watch();

  const { isFetching, isError } = useQuery({
    queryKey: ['getClaims', selectedCompany, filters.claimStatus],
    queryFn: ({ signal }) => {
      return fetchClaims(
        selectedCompany!,
        filters.claimStatus === 'all' ? undefined : filters.claimStatus,
        undefined,
        signal
      );
    },
    onSuccess: (claim) => {
      setData(claim);
    },
    refetchOnWindowFocus: false,
    enabled: !!selectedCompany,
  });

  if (isFetching || !selectedCompany)
    return (
      <div className="text-center mx-auto mt-3">
        <ProgressSpinner />
      </div>
    );

  if (isError)
    return (
      <ErrorMessage
        content={'Failed to obtain data! Please try again later.'}
      />
    );

  return (
    <ClaimsTable
      claims={data ?? []}
      showActiveColumn={filters.claimStatus === 'all'}
      filterStatus={filters.claimStatus}
    />
  );
});

export default ClaimsTableContainer;
